import errorImage from '@assets/img/error-logo.png';
import { CustomButton } from '@components';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { COLORS } from '@styles';

interface IErrorComponentProps {
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  title?: string;
  description?: string;
}

const sx = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    maxWidth: '390px',
    gap: '1rem',
  },
  image: {
    width: 'auto',
    height: '187px',
  },
  title: {
    fontFamily: 'Urbanist',
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: '40px',
    color: COLORS.NEUTRAL_100,
  },
  description: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: COLORS.NEUTRAL_100,
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '1rem',
    marginTop: '2.5rem',
  },
}


export function ErrorComponent({ primaryButtonLabel, secondaryButtonLabel, onPrimaryButtonClick, onSecondaryButtonClick, title, description }: IErrorComponentProps) {
  return (
    <Box sx={sx.container}>
      <img src={errorImage} alt="error" style={sx.image} />
      <Typography variant="h4" sx={sx.title}>
        {title || 'Something went wrong'}
      </Typography>
      <Typography variant="subtitle1" sx={sx.description}>
        {description || 'An error has occurred while processing your request. Please try again later or contact support team for further assistance.'}
      </Typography>

      <Box sx={sx.buttonContainer}>
        <CustomButton variant="default" onClick={onPrimaryButtonClick}>{primaryButtonLabel || 'Retry'}</CustomButton>
        <CustomButton variant="secondary" onClick={onSecondaryButtonClick}>{secondaryButtonLabel || 'Return'}</CustomButton>
      </Box>
    </Box>
  );
}